module.exports = __webpack_public_path__ + "img/logoEn.7c73577d.png";